import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllExpenses = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/expenses',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveExpense = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/expenses',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateExpense = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/expenses/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteExpense = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/expenses/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllExpenses,
  saveExpense,
  deleteExpense,
  updateExpense,
}
